import { render } from "./BiographyEditPage.vue?vue&type=template&id=13109280&scoped=true"
import script from "./BiographyEditPage.vue?vue&type=script&lang=js"
export * from "./BiographyEditPage.vue?vue&type=script&lang=js"

import "./BiographyEditPage.vue?vue&type=style&index=0&id=13109280&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13109280"]])

export default __exports__